



























import { Component, Prop, Vue } from "vue-property-decorator";
import { MiraDonutArc, donutArcs } from "@/utils/MiraOverview";

const RADIUS = 40;
const STROKE_WIDTH = 12;
/** The join between two parts, in viewBox units: about 2px at the rendered size. */
const JOIN_GAP = 2;

/** One part of the ring. */
export interface MiraDonutSegment {
  key: string;
  value: number;
  color: string;
}

/**
 * A ring with a number in its centre: parts of a whole, clockwise from the top, with a surface gap
 * between parts. The landing page's availability ring and the meter readings on Datenqualität.
 *
 * A ring, not a filled pie (market research 2026-09-30, see `docs/analytics/mira-office-screens.md`):
 * the centre number carries the value, the ring gives the shape at a glance. The parts are always also
 * listed as text beside the ring by the caller, so colour and arc length never carry a value alone.
 * The arcs draw in once on first render; `prefers-reduced-motion` skips that.
 */
@Component
export default class MiraDonutComponent extends Vue {
  @Prop({ required: true })
  segments!: MiraDonutSegment[];

  @Prop({ required: true })
  centerText!: string;

  @Prop({ default: null })
  caption!: string | null;

  /** The empty ring, visible only where there is nothing to count. */
  @Prop({ required: true })
  trackColor!: string;

  @Prop({ required: true })
  ariaLabel!: string;

  @Prop({ default: 88 })
  size!: number;

  radius = RADIUS;
  strokeWidth = STROKE_WIDTH;
  circumference = 2 * Math.PI * RADIUS;
  /** False on the first frame, so the arcs grow from nothing instead of appearing at once. */
  drawn = false;

  get arcs(): MiraDonutArc[] {
    return donutArcs(this.segments, this.circumference, JOIN_GAP);
  }

  colorOf(key: string): string {
    return this.segments.find((segment) => segment.key === key)?.color ?? this.trackColor;
  }

  mounted() {
    // Two frames: one to paint the empty ring, one to start the transition from it.
    requestAnimationFrame(() => requestAnimationFrame(() => (this.drawn = true)));
  }
}
